<template>
  <v-app >

    <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />

      <v-container>
        <v-row >
          <v-col md="12" lg="12" cols="12">

            <v-alert
                :value="alertborrador"
                color="red"
                dark
                dismissible
                border="top"
                transition="scale-transition"
            >
              Su Negocio se borro con éxito.
            </v-alert>
            <v-alert
                :value="alertnuevo"
                color="primary"
                dark
                dismissible
                border="top"
                transition="scale-transition"
            >
              Su Negocio se agrego con éxito.
            </v-alert>
            <v-alert
                :value="alerteditar"
                color="green"
                dark
                dismissible
                border="top"
                transition="scale-transition"
            >
              Su Negocio se edito con éxito.
            </v-alert>


            <v-dialog v-model="edialog" max-width="500px" persistent>
              <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo Negocio</v-btn>
            </template>
              <v-card color="#393E46">
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                  <v-stepper vertical v-model="e6">
                    <v-stepper-step :complete="e6>1" step="1">
                      Datos  <v-icon>fas fa-briefcase</v-icon>
                    </v-stepper-step>
                    <v-stepper-content step="1">
                      <v-row>
                        <v-col cols="12">
                          <v-card flat color="#393E46">

                            <v-card-text>
                              <v-row>
                                <v-col cols="12">
                                  <v-text-field prepend-icon="fas fa-briefcase" :counter="200" required v-model="editedItem.negocio" label="Nombre"></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                  <v-text-field prepend-icon="fas fa-tag" :counter="200" required v-model="editedItem.tag" label="tag"></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                  <v-autocomplete
                                      :items="Clientes"
                                      v-model="editedItem.cliente"
                                      return-object
                                      item-text="cliente"
                                      label="Escoge un Cliente"
                                  >

                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                              <v-row><v-col cols="12">
                                <v-autocomplete
                                    :items="TipoNegocios"
                                    return-object
                                    v-model="editedItem.tipoNegocio"
                                    item-text="tipoNegocio"
                                    item-value="id"
                                    label="Que tipo de negocio es ?"
                                >

                                </v-autocomplete></v-col>
                              </v-row>
                            </v-card-text>
                            <v-card-actions>
                              <v-row>
                                <v-col cols="12">
                                  <v-btn color="blue darken-1" text @click="close">Cerrar</v-btn>
                                  <v-btn color="blue darken-1" text @click="save">Siguiente</v-btn>
                                </v-col>
                              </v-row>
                            </v-card-actions>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-stepper-content>

                    <v-stepper-step :complete="e6 > 2" step="2">
                      Horario  <v-icon>fas fa-clock</v-icon>
                    </v-stepper-step>
                    <v-stepper-content step="2">


                    </v-stepper-content>
                  </v-stepper>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogdelete" persistent max-width="350">
              <v-card color="#393E46">
                <v-card-title class="headline">Desea eliminar esta Negocio?</v-card-title>
                <v-card-text>Estos datos no se volveran a visualizar en el sistema.</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green darken-1" text @click="close">No</v-btn>
                  <v-btn color="primary darken-1" text @click="borralo">SI</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialoguploadfoto"  persistent max-width="600">
              <v-card color="#393E46">
                <v-card-title class="headline">Logos</v-card-title>
                <v-card-text>
                  <v-tabs
                      v-model="tab"
                      centered
                      dark
                  >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab-logo90">
                      Logo 90
                    </v-tab>
                    <v-tab href="#tab-logo180">
                      Logo 180
                    </v-tab>
                    <v-tab href="#tab-logo270">
                      Logo 270
                    </v-tab>
                    <v-tab-item  key="tab-logo90" value="tab-logo90">
                      <v-row>
                        <v-col md="12" lg="12" cols="12">
                          <v-img width="90px" :src="editedItem.logo90"  />
                        </v-col>
                        <v-col md="12" lg="12" cols="12">
                          <v-file-input
                              label="Subir Nuevo Logo 90x90"
                              accept="image/*"
                              filled
                              chips
                              v-model="imagen90"
                              @change="onFileChange90"
                              prepend-icon="mdi-camera"
                          ></v-file-input>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item  key="tab-logo180" value="tab-logo180">
                      <v-row>
                        <v-col md="12" lg="12" cols="12">
                          <v-img width="180px" :src="editedItem.logo180"  />
                        </v-col>
                        <v-col md="12" lg="12" cols="12">
                          <v-file-input
                              label="Subir Nuevo Logo 180x180"
                              accept="image/*"
                              filled
                              chips
                              v-model="imagen180"
                              @change="onFileChange180"
                              prepend-icon="mdi-camera"
                          ></v-file-input>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item  key="tab-logo270" value="tab-logo270">
                      <v-row>
                        <v-col md="12" lg="12" cols="12">
                          <v-img width="270px" :src="editedItem.logo270"  />
                        </v-col>
                        <v-col md="12" lg="12" cols="12">
                          <v-file-input
                              label="Subir Nuevo Logo 270x270"
                              accept="image/*"
                              filled
                              chips
                              v-model="imagen270"
                              @change="onFileChange270"
                              prepend-icon="mdi-camera"
                          ></v-file-input>
                        </v-col>
                      </v-row>
                    </v-tab-item>

                  </v-tabs>

                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green darken-1" text @click="dialoguploadfoto=false">Cerrar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>


            <div >
              <v-data-table
                  :headers="headers"
                  :items="Negocios"
                  sort-by="Negocio"
                  sort-desc
                  show-expand
                  :expanded.sync="expanded"
                  :single-expand="singleExpand"
                  class="elevation-1"
                  :search="search"
                  :loading="progr"
                  no-data-text="No hay datos disponibles para mostrar."
                  no-results-text="No hay resultados para la búsqueda."
                  loading-text="Cargando... Por favor espere."
                  style="background-color: #393E46;"
              >
                <template v-slot:top>
                  <v-toolbar flat >
                    <v-toolbar-title>Negocios</v-toolbar-title>
                    <v-progress-circular
                        indeterminate
                        v-if="progr == true"
                        color="primary"
                    ></v-progress-circular>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>
                    <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
                    <v-spacer></v-spacer>


                  </v-toolbar>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                  <v-icon
                      small
                      color="primary"
                      class="mr-2"
                      v-bind="attrs"
                      v-on="on"
                      @click="editItem(item)"
                  >
                    fas fa-edit
                  </v-icon>
                    </template>
                    <span>Actualizar</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                  <v-icon
                      small
                      color="error"
                      class="mr-2"
                      v-bind="attrs"
                      v-on="on"
                      @click="deleteItem(item)"
                  >
                    fas fa-minus-circle
                  </v-icon>
                    </template>
                    <span>Borrar</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                          small
                          color="#f7be64"
                          class="mr-2"
                          v-bind="attrs"
                          v-on="on"
                          @click="fotoItem(item)"
                      >
                        fas fa-camera-retro
                      </v-icon>
                    </template>
                    <span>Logo</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                          small
                          color="secondary"
                          class="mr-2"
                          v-bind="attrs"
                          v-on="on"
                          @click="fiestaItem(item)"
                      >
                        fas fa-glass-cheers
                      </v-icon>
                    </template>
                    <span>Fiestas</span>
                  </v-tooltip>

                </template>

                <template v-slot:[`item.activ`]="{ item }">
                  <v-switch v-model="item.activo" @click="activaNegocio(item)" ></v-switch>
                </template>

                <template v-slot:no-data>
                  <v-btn color="primary" @click="dameNegocios">Cargar de Nuevo</v-btn>
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                  <td  :colspan="headers.length">
                    <v-row>
                      <v-col cols="4">Desea Compartir su Club al Publico en la Pagina</v-col>
                      <v-col cols="2"> <v-switch v-model="item.publico" @click="activaNegocio(item)" ></v-switch></v-col>
                    </v-row><v-row>
                      <v-col>Dias de Atención</v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="2" lg="1" md="2" sm="3">Lunes</v-col>
                      <v-col cols="2" lg="1" md="2" sm="3">Martes</v-col>
                      <v-col cols="2" lg="1" md="2" sm="3">Miercoles</v-col>
                      <v-col  cols="2" lg="1" md="2" sm="3">Domingo</v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="2" lg="1" md="2" sm="3"> <v-switch v-model="item.lunes" @click="activaNegocio(item)" ></v-switch></v-col>
                      <v-col cols="2" lg="1" md="2" sm="3"> <v-switch v-model="item.martes" @click="activaNegocio(item)" ></v-switch></v-col>
                      <v-col cols="2" lg="1" md="2" sm="3"> <v-switch v-model="item.miercoles" @click="activaNegocio(item)" ></v-switch></v-col>
                      <v-col cols="2" lg="1" md="2" sm="3"> <v-switch v-model="item.domingo" @click="activaNegocio(item)" ></v-switch></v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="2" lg="1" md="2" sm="3">Jueves</v-col>
                      <v-col cols="2" lg="1" md="2" sm="3">Viernes</v-col>
                      <v-col cols="2" lg="1" md="2" sm="3">Sabado</v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="2" lg="1" md="2" sm="3"> <v-switch v-model="item.jueves" @click="activaNegocio(item)" ></v-switch></v-col>
                      <v-col cols="2" lg="1" md="2" sm="3"> <v-switch v-model="item.viernes" @click="activaNegocio(item)" ></v-switch></v-col>
                      <v-col cols="2" lg="1" md="2" sm="3"> <v-switch v-model="item.sabado" @click="activaNegocio(item)" ></v-switch></v-col>
                    </v-row>
                  </td>
                </template>
              </v-data-table>
            </div>

          </v-col>
        </v-row>
        <leftmenusuperadmin />
        <v-overlay :value="overlay">
          <v-progress-circular
              indeterminate
              size="64"
          ></v-progress-circular>
        </v-overlay>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import axios from 'axios';
import moment from "moment";
import leftmenusuperadmin from "@/components/general/leftmenusuperadmin";
import store from "@/store";
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {
  title: 'Negocios | Tunay Mi acceso de bolsillo',

  components: {
    Cabecerabaja,
    leftmenusuperadmin
  },
  data: () => ({
    vistatabla: false,
    drawer: null,
    overlay:false,
    progr: true,
    token:'',
    alertborrador: false,
    alertnuevo: false,
    alerteditar: false,
    dialog: false,
    e6: 1,
    categoriafiesta: 0,
    tipoevento: 0,
    steps: 4,
    tab:null,
    e1: 1,
    imagen90:null,
    imagen180:null,
    imagen270:null,
    edialog: false,
    confdialog: false,
    dialogdelete: false,
    dialogcontactos: false,
    date: new Date().toISOString().substr(0, 10),
    date2: new Date().toISOString().substr(0, 10),
    dialoguploadfooter: false,
    dialoguploadcabecera: false,
    dialoguploadfoto: false,
    menu1: false,
    menu2: false,
    menu3: false,
    modal3: false,
    modal4: false,
    menu4: false,
    time: null,
    time2: null,
    Negocios: [],
    singleExpand: true,
    expanded:[],
    Clientes: [],
    TipoNegocios: [],
    eventoId: 0,
    NegocioContactos:[],
    SelectedNegocioContacots:[],
    search: '',
    editedIndex: -1,
    editedItem: {
      id: 0,
      negocio: "",
      cliente: {},
      logo:"",
      pais: {},
      icono: "",
      impuesto:"",
      activo: false,
      moneda: {},
      latitud: 0,
      longitud:0,
      tag: "",
      createdAt: null,
      tipoNegocio: {},
      horaApertura: "",
      horaCierre: "",
      direccion: "",
      mailreserva: "",
      facebook: "",
      instagram : "",
      website: "",
      logo90:"",
      logo180:"",
      logo270: "",
      restricciones : "",
      ciudad:{},
      cantMinutos:0,
      minutosVenc:0,
      periocidad:{}
    },
    defaultItem: {
      id: 0,
      negocio: "",
      cliente: {},
      logo:"",
      pais: {},
      icono: "",
      impuesto:"",
      activo: false,
      moneda: {},
      latitud: 0,
      longitud:0,
      tag: "",
      createdAt: null,
      tipoNegocio: {},
      horaApertura: "",
      horaCierre: "",
      direccion: "",
      mailreserva: "",
      facebook: "",
      instagram : "",
      website: "",
      logo90:"",
      logo180:"",
      logo270: "",
      restricciones : "",
      ciudad:{},
      cantMinutos:0,
      minutosVenc:0,
      periocidad:{}
    },
    headers: [
      { text: '', value: 'data-table-expand', sortable: false },
      { text: 'Acciones', value: 'action', sortable: false },
      { text: 'Negocio', align: 'left',  value: 'negocio'},
      { text: 'Cliente', align: 'left',  value: 'cliente.cliente'},
      { text: 'Tipo de Negocio', align: 'left',  value: 'tipoNegocio.tipoNegocio'},
      { text: 'Ciudad', align: 'left',  value: 'ciudad.ciudad'},
      { text: 'Activo', value: 'activ', sortable: false },

    ]
  }),
  mounted (){
    this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
    this.dameNegocios();
    this.dameClientes();
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  methods : {
    formatDatee(value) {
      return moment(value).locale('es-pe').format("DD MMMM YYYY")
    },
    cambiaTab(number){
      this.e6=number
    },
    dameTiposNegocio(){
      this.overlay = true;
      this.progr = true;
      let urlCliente = 'general/tiponegocios';
      axios
          .get(urlCliente,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.TipoNegocios = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
            this.overlay = false;
          })
          .catch((error)  => {
            console.log(error);
            this.progr = false;
          });
    },
    dameClientes(){
      this.overlay = true;
      this.progr = true;
      let urlCliente = 'clientes';
      axios
          .get(urlCliente,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.Clientes = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
            this.overlay = false;
            this.dameTiposNegocio()
          })
          .catch((error)  => {
            console.log(error);
            this.progr = false;
          });
    },

    dameNegocios(){
      this.overlay = true;
      this.progr = true;
      let urlNegocio = 'negocios/todos';
      axios
          .get(urlNegocio,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.Negocios = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
            this.overlay = false;
          })
          .catch((error)  => {
            console.log(error);
            this.progr = false;
          });
    },
    formatDate (date) {
      return moment(date).locale('es-pe').format("YYYY-MM-DD");
    },
    formatDatree(value) {
      return moment(value).locale('es-pe').format("DD-MM-YYYY")
    },
    irpaso1(){
      this.$router.push({name:'CreaPaso1'});
    },
    formatTime (date) {
      let hora = new Date('2020-10-10 '+date)
      return moment(hora).locale('es-pe').format("HH:mm");
    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    onFileChange90(e) {
      var bodyFormData = new FormData();
      bodyFormData.append("file",this.imagen90);
      let url = "negocios/logo/" + this.negocio.id + "/90"
      this.overlay = true
      axios
          .post(url,bodyFormData,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            console.assert(true,response);
            this.dialoguploadimage = false;
            this.overlay = false
          })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
          });
      console.log(e)
    },
    onFileChange180(e) {
      this.negocio.logo180= URL.createObjectURL(this.imagen180)
      var bodyFormData = new FormData();
      bodyFormData.append("file",this.imagen180);
      let url = "negocios/logo/" + this.negocio.id + "/180"
      this.overlay = true
      axios
          .post(url,bodyFormData,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            console.assert(true,response);
            this.dialoguploadimage = false;
            this.overlay = false
          })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
          });
      console.log(e)
    },
    onFileChange270(e) {
      this.negocio.logo270= URL.createObjectURL(this.imagen270)

      var bodyFormData = new FormData();
      bodyFormData.append("file",this.imagen270);
      let url = "negocios/logo/" + this.negocio.id + "/270"
      this.overlay = true
      axios
          .post(url,bodyFormData,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            console.assert(true,response);
            this.dialoguploadimage = false;
            this.overlay = false
          })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
            this.overlay = false;
          });
      console.log(e)
    },

    activaNegocio (item) {
      this.editedItem = Object.assign({}, item)
      var bodyFormData2 = new FormData();
      bodyFormData2.append("data",JSON.stringify(this.editedItem));
      axios
          .post('negocios/grabar',bodyFormData2,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          }).then(response => {
        console.log(response);
      })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
          });
    },
    editItem (item) {
      this.editedIndex = this.Negocios.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.edialog = true
    },
    fiestaItem(item){
      this.$router.push({ name: 'FiestasNegocios', params: { idnegocio: item.tag }})
    },
    fotoItem(item){
      this.editedIndex = this.Negocios.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialoguploadfoto = true
    },
    configItem (item) {
      this.editedIndex = this.Negocios.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.confdialog = true
    },
    deleteItem (item) {
      this.editedIndex = this.Negocios.indexOf(item);
      this.dialogdelete = true;
    },
    irZona(item){
      this.editedIndex = this.Negocios.indexOf(item);
      this.editedItem = Object.assign({}, item)
      store.dispatch("fetchNegocio", this.editedItem);

      this.$router.push({name:'ZonaNegocio'})
    },
    irEntradas(item){
      this.editedIndex = this.Negocios.indexOf(item);
      this.editedItem = Object.assign({}, item)
      store.dispatch("fetchNegocio", this.editedItem);
      this.$router.push({name:'TicketNegocio'})
    },
    borralo (){
      let idevento = this.Negocios[this.editedIndex].id
      axios
          .delete('eventos/'+idevento,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.dialogdelete = false;
            this.alertborrador = true;
            this.Negocios = response.data
          })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
          });
    },
    close () {
      this.dialog = false;
      this.edialog = false;
      this.confdialog = false;
      this.dialogdelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    graba(item){
      var bodyFormData2 = new FormData();
      item.fechaInicio = this.formatDatree(item.fechaInicio)
      item.fechaFinal = this.formatDatree(item.fechaFinal)
      bodyFormData2.append("data",JSON.stringify(item));
      axios
          .post('eventos/grabaevento',bodyFormData2,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          }).then(response => {
        this.Negocios = response.data
        this.alerteditar = true;

      })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
          });
    },
    save () {
      var bodyFormData2 = new FormData();
      if (this.editedIndex > -1) {
        Object.assign(this.Negocios[this.editedIndex], this.editedItem);
        this.editedItem.fechaInicio = this.formatDatree(this.editedItem.fechaInicio)
        this.editedItem.fechaFinal = this.formatDatree(this.editedItem.fechaFinal)
        this.editedItem.horaInicio = this.formatTime(this.editedItem.horaInicio)
        this.editedItem.horaFinal = this.formatTime(this.editedItem.horaFinal)
        bodyFormData2.append("data",JSON.stringify(this.editedItem));

        axios
            .post('negocio/grabar',bodyFormData2,{
              headers: {
                'Authorization': `Bearer ${this.token}`,
              }
            }).then(response => {
          this.Negocios = response.data
          this.alerteditar = true;

        })
            .catch(error => {
              this.error = "Hubo un error";
              console.log(error);
            });
      } else {
        this.editedItem.fechaInicio = this.formatDatree(this.editedItem.fechaInicio)
        this.editedItem.fechaFinal = this.formatDatree(this.editedItem.fechaFinal)
        this.editedItem.horaInicio = this.formatTime(this.editedItem.horaInicio)
        this.editedItem.horaFinal = this.formatTime(this.editedItem.horaFinal)
        bodyFormData2.append("data",JSON.stringify(this.editedItem));

        axios
            .post('eventos/grabaevento',bodyFormData2,{
              headers: {
                'Authorization': `Bearer ${this.token}`,
              }
            }).then(response => {
          this.dameNegocios();
          this.alertnuevo = true;
          console.log(response);
        })
            .catch(error => {
              this.error = "Hubo un error";
              console.log(error);
            });
      }
      this.close()
    },
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    formTitle () {
      return this.editedIndex === -1 ? 'Nueva Negocio' : 'Editar Negocio'
    },
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    ...mapGetters({
      user: "user",
      usuario: "usuario",
      cliente: "cliente"
    })
  }
};
</script>